import(/* webpackMode: "eager" */ "/var/www/html/Ariel/src/app/services/page.tsx");
